var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_118_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 16,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.75H1.5V17.25H16.5V0.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_118_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5472 5.19681V8.00535H12.248V5.66489H8.46847V2.03723H2.6811V14.5585H7.40551V15.8458H2.91732C2.20866 15.8458 1.5 15.2606 1.5 14.4415V2.15425C1.5 1.3351 2.09055 0.75 2.91732 0.75H9.05903L13.5472 5.19681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 7.77148H4.09839V9.05871H10.0039V7.77148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64169 10.1118H4.09839V11.399H7.64169V10.1118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 14.6755L15.555 13.9733V13.8563C15.555 13.7393 15.555 13.6223 15.555 13.5052C15.555 13.3882 15.555 13.2712 15.555 13.1542V13.0372L16.4999 12.335C16.4999 12.335 16.4999 12.335 16.4999 12.218L15.6731 11.0478C15.6731 11.0478 15.6731 11.0478 15.555 11.0478L14.6101 11.3989H14.492C14.2558 11.2819 14.1377 11.1649 13.9014 11.0478H13.7833L13.6652 9.99463H12.1298L11.8935 11.0478H11.7755C11.6574 11.1649 11.4211 11.2819 11.1849 11.3989H11.0668L10.1219 11.0478C10.0038 11.0478 10.0038 11.0478 10.0038 11.0478L9.29517 12.4521C9.29517 12.4521 9.29517 12.4521 9.29517 12.5691L10.24 13.2712V13.3882C10.24 13.6223 10.24 13.8563 10.24 14.0904V14.2074L9.29517 14.9095C9.29517 14.9095 9.29517 14.9095 9.29517 15.0265L10.1219 16.3138C10.1219 16.3138 10.1219 16.3138 10.24 16.3138L11.1849 15.9627H11.303C11.5392 16.0797 11.7755 16.1968 11.8935 16.3138H12.0117L12.1298 17.2499C12.1298 17.2499 12.1298 17.2499 12.2479 17.2499H13.7833L13.9014 16.1968H14.0196C14.2558 16.0797 14.3739 15.9627 14.6101 15.8457H14.7282L15.6731 16.1968C15.7912 16.1968 15.7912 16.1968 15.7912 16.1968L16.4999 14.6755ZM12.9566 14.9095C12.2479 14.9095 11.6574 14.3244 11.6574 13.6223C11.6574 12.9202 12.2479 12.335 12.9566 12.335C13.6652 12.335 14.2558 12.9202 14.2558 13.6223C14.2558 14.3244 13.6652 14.9095 12.9566 14.9095Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardActive);
export default __webpack_public_path__ + "static/media/Onboard-active.94b59880cd9c156efb6695d52db19b4a.svg";
export { ForwardRef as ReactComponent };